import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/ai-face-swap"
    exact
    path="/consumer/features/ai-face-swap"
    component={AsyncPage}
  />,
];
